import React, { memo, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Button, Icon, Stack } from "investira.react.components";
import { PageTemplate } from "../../../components/templates";
import { OUTPUT } from "../../../enums";
import EnquadramentoRegras from "../_components/EnquadramentoRegras";
import EnquadramentoRegrasAddDialog from "../_components/EnquadramentoRegrasAddDialog";
import EnquadramentoRegrasCopyDialog from "../_components/EnquadramentoRegrasCopyDialog";
import withRegras from "../../../hoc/withRegras";
import useKickBack from "../../../hooks/useKickBack";
import withMessage from "../../../hoc/withMessage";

const ReportSettingsRegras = memo((props) => {
  const params = useParams();
  const location = useLocation();

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(false);
  }

  const kick = useKickBack();

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  return (
    <PageTemplate
      title={location.state.enquadramento}
      subtitle={`${OUTPUT[params.output].descricao}`}
      maxWidth="xl"
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="papers" size={16} />}
            size="small"
            sx={{ px: 2, whiteSpace: "nowrap" }}
            onClick={() => setOpen("C")}
          >
            Copiar Regras
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="insert" size={16} />}
            size="small"
            sx={{ px: 2, whiteSpace: "nowrap" }}
            onClick={() => setOpen("N")}
          >
            Adicionar Regra
          </Button>
        </Stack>
      }
    >
      <EnquadramentoRegras {...props} />
      <EnquadramentoRegrasAddDialog
        key={"add-enquadramento-dialog"}
        open={open === "N"}
        onClose={handleClose}
        data={props.regras}
        readData={props.readRegras}
        enquadramentoId={params.id}
      />
      <EnquadramentoRegrasCopyDialog
        key={"copy-enquadramento-dialog"}
        open={open === "C"}
        onClose={handleClose}
        data={props.regras}
        readData={props.readRegras}
        enquadramentoId={params.id}
      />
    </PageTemplate>
  );
});

export default withRegras(withMessage(ReportSettingsRegras));
